import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import { PlanViewerWithPopup } from '../../../RegulatoryMember/ExitRequestDetail/PlanViewerWithPopup';
import { UI_TEXT, RESTRICTION_TYPES } from './ExitPlanPage.constants';
import { labelTextStyles, valueTextStyles, descriptionPaperStyles } from '@Pages/RnDMember/ExitRequestResponseUnified/ExitRequestResponseStyles';
import { isExemption } from '@Utils/planType';

export const PlanViewContent = ({ planDetails, restrictionType, theme }) => {
    const formatDate = (date) => date ? new Date(date).toLocaleDateString() : UI_TEXT.NA;

    // if (restrictionType === RESTRICTION_TYPES.BANNED) {
    //     return (
    //         <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, mt: 0 }}>
    //             <Typography variant="body2" color="textSecondary" sx={{ ...labelTextStyles, mt: 1, fontSize: '0.95rem' }}>
    //                 {UI_TEXT.EXIT_DATE}
    //             </Typography>
    //             <Paper variant="outlined" sx={{ ...descriptionPaperStyles(theme), maxHeight: 150 }}>
    //                 <Typography variant="body2" sx={{ ...valueTextStyles, fontSize: '0.95rem' }}>
    //                     {formatDate(planDetails.exitDate)}
    //                 </Typography>
    //             </Paper>

    //             <PlanViewerWithPopup
    //                 title={UI_TEXT.REPLACEMENT_PLAN}
    //                 content={planDetails.replacementPlan || UI_TEXT.NA}
    //             />

    //             <Typography variant="body2" color="textSecondary" sx={{ ...labelTextStyles, mt: 1, fontSize: '0.95rem' }}>
    //                 {UI_TEXT.ADDITIONAL_COMMENTS}
    //             </Typography>
    //             <Paper variant="outlined" sx={{ ...descriptionPaperStyles(theme), maxHeight: 150 }}>
    //                 <Typography variant="body2" sx={{ ...valueTextStyles, fontSize: '0.95rem' }}>
    //                     {planDetails.additionalComments || UI_TEXT.NO_ADDITIONAL_INFO}
    //                 </Typography>
    //             </Paper>
    //         </Box>
    //     );
    // }

    // Treat RESTRICTED, LABELING_REQUIREMENTS, and RESTRICTIONS_AND_LABELING the same
    // if (
    //     restrictionType === RESTRICTION_TYPES.BANNED ||
    //     restrictionType === RESTRICTION_TYPES.RESTRICTED ||
    //     restrictionType === RESTRICTION_TYPES.LABELING_REQUIREMENTS ||
    //     restrictionType === RESTRICTION_TYPES.RESTRICTIONS_AND_LABELING
    // ) {
        return (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
                <Box sx={{ display: 'flex', flexDirection: 'row', gap: 2 }}>
                    <Box sx={{ flex: 1 }}>
                        <Typography variant="body2" color="textSecondary" sx={{ ...labelTextStyles, mt: 1, fontSize: '0.95rem' }}>
                            {UI_TEXT.END_OF_PRODUCTION_DATE}
                        </Typography>
                        <Paper variant="outlined" sx={{ ...descriptionPaperStyles(theme), maxHeight: 150 }}>
                            <Typography variant="body2" sx={{ ...valueTextStyles, fontSize: '0.95rem' }}>
                                {formatDate(planDetails.endOfProductionDate)}
                            </Typography>
                        </Paper>
                    </Box>
                    <Box sx={{ flex: 1 }}>
                        <Typography variant="body2" color="textSecondary" sx={{ ...labelTextStyles, mt: 1, fontSize: '0.95rem' }}>
                            {UI_TEXT.END_OF_IMPORTATION_DATE}
                        </Typography>
                        <Paper variant="outlined" sx={{ ...descriptionPaperStyles(theme), maxHeight: 150 }}>
                            <Typography variant="body2" sx={{ ...valueTextStyles, fontSize: '0.95rem' }}>
                                {formatDate(planDetails.endOfImportationDate)}
                            </Typography>
                        </Paper>
                    </Box>
                </Box>

                <PlanViewerWithPopup
                    title={UI_TEXT.LIQUIDATION_PLAN}
                    content={planDetails.liquidationPlan || UI_TEXT.NA}
                />

                {isExemption(planDetails) && (
                    <>
                        <Box sx={{ display: 'flex', flexDirection: 'row', gap: 2 }}>
                            <Box sx={{ flex: 1 }}>
                                <Typography variant="body2" color="textSecondary" sx={{ ...labelTextStyles, mt: 1, fontSize: '0.95rem' }}>
                                    Exception start date
                                </Typography>
                                <Paper variant="outlined" sx={{ ...descriptionPaperStyles(theme), maxHeight: 150 }}>
                                    <Typography variant="body2" sx={{ ...valueTextStyles, fontSize: '0.95rem' }}>
                                        {formatDate(planDetails.exceptionStartDate)}
                                    </Typography>
                                </Paper>
                            </Box>
                            <Box sx={{ flex: 1 }}>
                                <Typography variant="body2" color="textSecondary" sx={{ ...labelTextStyles, mt: 1, fontSize: '0.95rem' }}>
                                    Exception end date
                                </Typography>
                                <Paper variant="outlined" sx={{ ...descriptionPaperStyles(theme), maxHeight: 150 }}>
                                    <Typography variant="body2" sx={{ ...valueTextStyles, fontSize: '0.95rem' }}>
                                        {formatDate(planDetails.exceptionEndDate)}
                                    </Typography>
                                </Paper>
                            </Box>
                        </Box>
                        <Box sx={{ display: 'flex', flexDirection: 'row', gap: 2 }}>
                            <Box sx={{ flex: 1 }}>
                                <Typography variant="body2" color="textSecondary" sx={{ ...labelTextStyles, mt: 1, fontSize: '0.95rem' }}>
                                    TO impact (Euros)
                                </Typography>
                                <Paper variant="outlined" sx={{ ...descriptionPaperStyles(theme), maxHeight: 150 }}>
                                    <Typography variant="body2" sx={{ ...valueTextStyles, fontSize: '0.95rem' }}>
                                        {planDetails.toImpactEuros === '' || planDetails.toImpactEuros == null ? UI_TEXT.NA : `${planDetails.toImpactEuros} EUR`}
                                    </Typography>
                                </Paper>
                            </Box>
                            <Box sx={{ flex: 1 }}>
                                <Typography variant="body2" color="textSecondary" sx={{ ...labelTextStyles, mt: 1, fontSize: '0.95rem' }}>
                                    Pharos/Pelican safety assessment ref.
                                </Typography>
                                <Paper variant="outlined" sx={{ ...descriptionPaperStyles(theme), maxHeight: 150 }}>
                                    <Typography variant="body2" sx={{ ...valueTextStyles, fontSize: '0.95rem' }}>
                                        {planDetails.safetyAssessmentReference || UI_TEXT.NA}
                                    </Typography>
                                </Paper>
                            </Box>
                        </Box>
                        <Box sx={{ display: 'flex', flexDirection: 'row', gap: 2 }}>
                            <Box sx={{ flex: 1 }}>
                                <Typography variant="body2" color="textSecondary" sx={{ ...labelTextStyles, mt: 1, fontSize: '0.95rem' }}>
                                    Product types
                                </Typography>
                                <Paper variant="outlined" sx={{ ...descriptionPaperStyles(theme), maxHeight: 150 }}>
                                    <Typography variant="body2" sx={{ ...valueTextStyles, fontSize: '0.95rem' }}>
                                        {planDetails.productTypes || UI_TEXT.NA}
                                    </Typography>
                                </Paper>
                            </Box>
                            <Box sx={{ flex: 1 }}>
                                <Typography variant="body2" color="textSecondary" sx={{ ...labelTextStyles, mt: 1, fontSize: '0.95rem' }}>
                                    Brands
                                </Typography>
                                <Paper variant="outlined" sx={{ ...descriptionPaperStyles(theme), maxHeight: 150 }}>
                                    <Typography variant="body2" sx={{ ...valueTextStyles, fontSize: '0.95rem' }}>
                                        {planDetails.brands || UI_TEXT.NA}
                                    </Typography>
                                </Paper>
                            </Box>
                        </Box>
                        <PlanViewerWithPopup title="Justification" content={planDetails.justification || UI_TEXT.NA} />
                        {planDetails.localRiskAssessment && (
                            <PlanViewerWithPopup title="Local Regulatory Risk Assessment" content={planDetails.localRiskAssessment} />
                        )}
                    </>
                )}

                <Typography variant="body2" color="textSecondary" sx={{ ...labelTextStyles, mt: 0.5, fontSize: '0.95rem' }}>
                    {UI_TEXT.ADDITIONAL_COMMENTS}
                </Typography>
                <Paper variant="outlined" sx={{ ...descriptionPaperStyles(theme), maxHeight: 150 }}>
                    <Typography variant="body2" sx={{ ...valueTextStyles, fontSize: '0.95rem' }}>
                        {planDetails.additionalComments || UI_TEXT.NO_ADDITIONAL_INFO}
                    </Typography>
                </Paper>
            </Box>
        );
    // }

    // return null;
};